import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';
import { extraReducers } from './extra-reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const projectSlice = createAppSlice({
  name: 'project',
  initialState,
  reducers,
  extraReducers,
});

export const {
  setCreateProjectErrorFields,
  removeCreateProjectErrorFields,
  setWorkingProject,
  loadProject,
  loadPreviewTemplate,
  saveWorkingProject,
  saveWorkingProjectByFields,
  saveWorkingProjectSession,
  saveWorkingProjectSessionByField,
  getPublishedEventUrl,
  updateWorkingProjectWithIndexedDb,
  loadWorkingProjectWithIndexedDB,
  deleteSession,
  clearPreviewTemplate,
  setSavingWorkingProject,
  setSavingWorkingProjectError,
  setUpdatingSessionUuid,
  loadProjectGroups,
  setupProjectPreview,
  updateProjectSettings,
  setRegistrationOn,
  updateHomepageHeader,
  updateHomepageModule,
  addLeaderboardNavItem,
  updateRegistrationSteps,
  clearSaveSessionAfterProjectSave,
  setActivePreviewPageTab,
  setDisplayEditProjectThemeTray,
  setDisplayPreviewTemplateThemeTray,
  setShowUpdateProjectTypeModal,
  publishWorkingProject,
  getProjectScheduledEmails,
  editScheduledEmail,
  setSelectEditOrPublishButtonState,
  setShowUneditedContent,
  setPreviewTemplateOverrides,
  duplicateSession,
  clearPublishedEventUrl,
  setIsCreatingNewSession,
  setWorkingProjectTheme,
  updateProjectPreviewPassword,
  loadMostRecentActivityLog,
  updateMostRecentActivity,
  duplicateProject,
  loadWorkingSession,
  updatePublishSettings,
  setFavicon,
  fetchGreenroomMeeting,
  updateSessionCrewAssociations,
  updateMeetingInviteSlice,
  revokeGreenroomInvitation,
  loadGreenroomMeeting,
  loadGreenroomData,
  fetchSessionEngagementTotals,
} = projectSlice.actions;

export default projectSlice.reducer;
